<template>
	<div class="detail-card-list flex-center-end" :rows="rows">
		<div class="detail-card-list-content flex-grow" :style="{'grid-template-columns': columns ? columns.join(' ') : ''}">
			<slot></slot>
		</div>
		<div v-if="addButtonName" class="detail-card-list-remove flex-center" @click="deleteButton ? $emit('delete') : ''"><i v-if="deleteButton" class="tf">&#xe627;</i></div>
	</div>
</template>

<script>
	import {getStore, mapStore} from '@deanwu/vue-component-library-mobile'

	export default {
		name: 'detailCardList',

		props: {
			columns: {
				type: Array,
				default() {
					return ['1fr']
				}
			},
			deleteButton: Boolean
		},

		data() {
			return {
				...getStore(this, 'detailCardStore'),
				rows: false
			}
		},
		
		computed: {
			...mapStore('detailCardStore', ['addButtonName'])
		}
	}
</script>

<style lang="stylus" scoped>
	.detail-card-list {
		+ .detail-card-list {
			margin-top: .2rem;

			&[rows] {
				border-top: 1px solid #eee;
				padding-top: .2rem;
			}
		}

		&-content {
			display: grid;
			grid-gap: .16rem;

			>>> .c-input,
			>>> .c-select,
			>>> .c-datetime {
				height: .6rem;
				background: #FFFAAD;
			}
		}

		&-remove {
			height: .6rem;
			width: 1em;
			padding: 0 .06rem 0 .26rem;
			font-size: .32rem;
			color: #f55;
		}
	}
</style>
